/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const share_android = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m5.83 6.594 4.34-1.687M5.736 8.619l4.526 2.263M6 7.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM15 4a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
    />
  </svg>
)
export default share_android
